import { ButtonClose } from "@/components/ui";
import { Oferta } from "@/landingPage/types/landingSections";

interface Props {
  o: Oferta;
  ofertas: Oferta[];
  updateOferta: (
    id: string,
    field: keyof Oferta,
    value: string | number
  ) => void;
  updateOfertas: (ofertas: Oferta[]) => void;
  handleRemoveOferta: (id: string) => void;
}

export default function OfertaCard({
  o,
  ofertas,
  updateOferta,
  updateOfertas,
  handleRemoveOferta,
}: Props) {
  const imagen = o.imagenes?.[0] ?? "/img/logo/LogoLinkServs.png";

  return (
    <div className="rounded-[28px] border border-white/10 bg-zinc-900/80 overflow-hidden">
      {/* Imagen */}
      <div className="aspect-[16/10] bg-zinc-800 overflow-hidden">
        <img
          src={imagen}
          alt={o.titulo ?? "Oferta"}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Form */}
      <div className="p-4 space-y-3 text-white">
        <input
          value={o.titulo ?? ""}
          placeholder="Título"
          onChange={(e) =>
            updateOferta(o.id!, "titulo", e.target.value)
          }
          className="w-full rounded-xl bg-zinc-950 border border-white/10 px-3 py-2 text-sm"
        />

        <textarea
          value={o.descripcion ?? ""}
          placeholder="Descripción"
          onChange={(e) =>
            updateOferta(o.id!, "descripcion", e.target.value)
          }
          className="w-full h-24 resize-none rounded-xl bg-zinc-950 border border-white/10 px-3 py-2 text-sm"
        />

        <input
          type="number"
          value={o.precio === 0 ? "" : String(o.precio)}
          placeholder="Precio"
          onChange={(e) =>
            updateOferta(
              o.id!,
              "precio",
              e.target.value === "" ? 0 : Number(e.target.value)
            )
          }
          className="w-full rounded-xl bg-zinc-950 border border-white/10 px-3 py-2 text-sm"
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (!file || !o.id) return;

            updateOfertas(
              ofertas.map((oferta) =>
                oferta.id === o.id
                  ? {
                      ...oferta,
                      imagenes: [
                        ...oferta.imagenes,
                        URL.createObjectURL(file),
                      ],
                      _pendingFile: file,
                    }
                  : oferta
              )
            );
          }}
          className="block w-full text-xs text-zinc-300
          file:mr-3 file:px-3 file:py-2 file:rounded-lg
          file:border-0 file:bg-zinc-800 file:text-white
          hover:file:bg-zinc-700"
        />

        <div className="flex justify-end">
          <ButtonClose onClick={() => handleRemoveOferta(o.id!)} />
        </div>
      </div>
    </div>
  );
}